import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import GUIA from './guiaConfiguracao';
import './GuiaConfiguracao.css';

function normalizar(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }

function textoDoTopico(t) {
  const partes = [t.titulo];
  for (const b of t.blocos) {
    if (b.texto) partes.push(b.texto);
    if (b.itens) partes.push(b.itens.join(' '));
  }
  return normalizar(partes.join(' '));
}

function Bloco({ bloco }) {
  if (bloco.tipo === 'codigo') {
    return (
      <pre className="guia-codigo"><code>{bloco.texto}</code></pre>
    );
  }
  if (bloco.tipo === 'nota') {
    return <div className="guia-nota"><i className="fas fa-lightbulb me-2" />{bloco.texto}</div>;
  }
  if (bloco.tipo === 'passos') {
    return <ol className="guia-passos">{bloco.itens.map((i, k) => <li key={k}>{i}</li>)}</ol>;
  }
  return <p className="guia-paragrafo">{bloco.texto}</p>;
}

function GuiaConfiguracao() {
  const history = useHistory();
  const [busca, setBusca] = useState('');
  const [ativo, setAtivo] = useState(GUIA[0] ? GUIA[0].id : null);

  const verificar = useCallback(async () => {
    const ok = await verificandoApp('ATENDENTE');
    if (!ok) history.push('/');
  }, [history]);
  useEffect(() => { verificar(); }, [verificar]);

  const topicos = useMemo(() => {
    const q = normalizar(busca.trim());
    if (!q) return GUIA;
    return GUIA.filter((t) => textoDoTopico(t).includes(q));
  }, [busca]);

  // se o tópico ativo sair do filtro, seleciona o primeiro visível
  useEffect(() => {
    if (topicos.length && !topicos.some((t) => t.id === ativo)) setAtivo(topicos[0].id);
  }, [topicos, ativo]);

  const topicoAtual = topicos.find((t) => t.id === ativo) || topicos[0];

  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        <div className="container-fluid titulo cadastro-unificado guia-page">
          <header className="guia-header">
            <h1 className="mb-0"><i className="fas fa-book-open me-2" />Guia de Configuração</h1>
            <p className="text-muted mb-2">Documentação das áreas de configuração e integrações do Tacoma.</p>
            <div className="guia-busca">
              <i className="fas fa-search" />
              <input
                type="text"
                className="guia-busca-input"
                placeholder="Buscar assunto (ex.: webhook, SLA, QR)…"
                value={busca}
                onChange={(e) => setBusca(e.target.value)}
              />
            </div>
          </header>

          {topicos.length === 0 ? (
            <p className="text-muted">Nenhum tópico encontrado para &quot;{busca}&quot;.</p>
          ) : (
            <div className="guia-corpo">
              <nav className="guia-nav">
                {topicos.map((t) => (
                  <button
                    key={t.id}
                    type="button"
                    className={`guia-nav-item ${topicoAtual && t.id === topicoAtual.id ? 'ativo' : ''}`}
                    onClick={() => setAtivo(t.id)}
                  >
                    <i className={`fas ${t.icone} me-2`} />{t.titulo}
                  </button>
                ))}
              </nav>
              <article className="guia-conteudo">
                {topicoAtual && (
                  <>
                    <h2 className="guia-conteudo-titulo"><i className={`fas ${topicoAtual.icone} me-2`} />{topicoAtual.titulo}</h2>
                    {topicoAtual.blocos.map((b, i) => <Bloco key={i} bloco={b} />)}
                  </>
                )}
              </article>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}

export default GuiaConfiguracao;
